/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CardScheme = {
    AMERICAN_EXPRESS: 'AMERICAN_EXPRESS',
    MASTERCARD: 'MASTERCARD',
    VISA: 'VISA'
} as const;
export type CardScheme = typeof CardScheme[keyof typeof CardScheme];


export function instanceOfCardScheme(value: any): boolean {
    for (const key in CardScheme) {
        if (Object.prototype.hasOwnProperty.call(CardScheme, key)) {
            if (CardScheme[key as keyof typeof CardScheme] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CardSchemeFromJSON(json: any): CardScheme {
    return CardSchemeFromJSONTyped(json, false);
}

export function CardSchemeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardScheme {
    return json as CardScheme;
}

export function CardSchemeToJSON(value?: CardScheme | null): any {
    return value as any;
}

export function CardSchemeToJSONTyped(value: any, ignoreDiscriminator: boolean): CardScheme {
    return value as CardScheme;
}

